import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { styled } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import noImage from './images/noImage.png';
import idle from './images/icons/idle_on.png';
import registered from './images/icons/registered_on.png';
import active from './images/icons/active_on.png';
import discontinued from './images/icons/discontinued_on.png';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import BrowserNotSupportedIcon from '@mui/icons-material/BrowserNotSupported';
import Avatar from '@mui/material/Avatar';
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import swal from 'sweetalert';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import DropDown from './components/DropDown';
import Config from './components/ClientConfig';
import Client from './components/Client';
import BackOfficeConfig from './Config';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import CloseIcon from "@mui/icons-material/Close";

import RecomFilters from './components/RecomFilters';
import ProductsFilters from './components/ProductsFilters';
/*
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
*/
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
const PRODUCT_COL_WIDTH = 300;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const toAbsoluteImg = (src) => {
  if (!src || src === "null") return "";

  let p = String(src).trim();

  // insert "_s" before extension (foo.jpg -> foo_s.jpg), or append if no extension
  const dot = p.lastIndexOf(".");
  p = dot > 0 ? `${p.slice(0, dot)}_s${p.slice(dot)}` : `${p}_s`;

  // absolute? return as-is
  if (/^https?:\/\//i.test(p)) return p;

  // prefix with your media base
  const base =
    (BackOfficeConfig &&
      (BackOfficeConfig.MEDIA_URL ||
       BackOfficeConfig.STATIC_URL ||
       BackOfficeConfig.FILES_URL)) || "";

  return base ? `${base}${p.startsWith("/") ? "" : "/"}${p}` : p;
};

const __subcatCache = Object.create(null);
const getSubCategoriesOnce = (client, categoryIref) => {
  if (!categoryIref) return null;
  const key = String(categoryIref);
  if (__subcatCache[key]) return __subcatCache[key];
  const data = client.getProductsSubCategories({ category: key });
  if (data && data.productSubCategories) {
    const map = {};
    for (let i = 0; i < data.productSubCategories.length; i++) {
      const sc = data.productSubCategories[i];
      map[sc.iref] = { name: sc.name, image: sc.image };
    }
    __subcatCache[key] = map;
    return map;
  }
  return null;
};

class RecommendsRow extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      client: new Client ( "none" ), 
      edit: false,
      row: {},
      productsSearch: [],
      product: {},
      recommendedBy: "",
      categories: this.props.categories || {},
      subCategories: this.props.subCategories || {},
    };

    this.handleEditClick = this.handleEditClick.bind(this);
    this.productsSearch = this.productsSearch.bind(this);
    this.productChange = this.productChange.bind(this);
    this.loadSubCategories = this.loadSubCategories.bind(this);
    this.pushData = this.pushData.bind(this);
  }

  componentDidMount () {
    if (this.props) {
      if (this.props.isNew === true) {
        this.handleEditClick();
      }
      if (this.props.row)
        this.setState ( {row: this.props.row } );
      if (this.props.saveURL) this.setState ( { saveURL: this.props.saveURL } );
      if (this.props.recommendedBy) this.setState ( { recommendedBy: this.props.recommendedBy } );
      // prefetch subcategories for this product’s category (pCategory is an iref)
      const pc = this.props.row?.pCategory;  // iref string
      if (pc) this.loadSubCategories(pc);
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps !== this.props) {
      if (this.props) {
        if (this.props.row) this.setState ( {row: this.props.row } );
        if (this.props.saveURL) this.setState ( { saveURL: this.props.saveURL } );
        if (this.props.recommendedBy) this.setState ( { recommendedBy: this.props.recommendedBy } );
        // if product category changed, refresh subcategories
        const prevPC = prevProps.row?.pCategory;
        const currPC = this.props.row?.pCategory;
        if (currPC && currPC !== prevPC) this.loadSubCategories(currPC);
      }
    }
  }

  handleEditClick ( ) {
    let cEdit = !this.state.edit;
    this.setState({ edit: !this.state.edit });
  }

  productsSearch ( e ) {
    if ( e.target.value.length > 2 ) {
      let queryData = {
        "nameLike" : e.target.value,
        "recommendedBy": this.state.recommendedBy,
        status: 2,
        isForSale: 1,
        orderBy_name: true,
      };

      // 1) PRODUCTS
      let data = this.state.client.filterProducts ({ ...queryData, "isSoldAlone": 1 });
      let newProducts = [];
      let users = [];
      if (data && data.products && data.products.length > 0) {
        Object.keys(data.products).forEach(key => {
          let fData = data.products[key];
          // show only products where isSoldAlone == true/1
          if (fData.isSoldAlone !== true && fData.isSoldAlone !== 1) {
            return;
          }
          let name = fData.name;
          let lineText = name;
          lineText += " (";
          if (fData.pCategory && fData.pCategory.name)
            lineText += fData.pCategory.name;
          if (fData.pSubCategory && fData.pSubCategory.name)
            lineText += "/" + fData.pSubCategory.name + ")";
          else
            lineText += ")";

          let newObj = { key: fData.iref, label: "[P] " + lineText, type: "product" };
          newProducts.push(newObj);
          users.push(fData);
        });
      }

      // 2) COMBOS – same query, using filterCombos
      let combosData = this.state.client.filterCombos(queryData);
      if (combosData && combosData.productCombos && combosData.productCombos.length > 0) {
        Object.keys(combosData.productCombos).forEach(key => {
          let fData = combosData.productCombos[key];
          let name = fData.name;
          let lineText = name;
          lineText += " (";
          if (fData.pCategory && fData.pCategory.name)
            lineText += fData.pCategory.name;
          if (fData.pSubCategory && fData.pSubCategory.name)
            lineText += "/" + fData.pSubCategory.name + ")";
          else
            lineText += ")";

          let newObj = { key: fData.iref, label: "[C] " + lineText, type: "combo" };
          newProducts.push(newObj);
          users.push(fData);
        });
      }

      this.setState({ productsSearch: newProducts });
    }
  }

  productChange ( e, v, productIref, recommIref ) {
    if (!v || !v.key) return;
    let queryData = { iref: v.key };

    // 1) Try PRODUCT endpoint
    let data = this.state.client.getData(Config.API_URL_PRODUCT, queryData);
    let product = null;
    if (data && data.products && data.products.length === 1) {
      product = data.products[0];
    }

    // 2) If not found as product, try COMBO endpoint
    if (!product) {
      let comboData = this.state.client.getData(Config.API_URL_COMBO, queryData);
      if (comboData && comboData.productCombos && comboData.productCombos.length === 1) {
        product = comboData.productCombos[0];   // still call it "product" for minimal changes
      }
    }
    if (product) {
      this.setState({ product: product });
      if (product.pCategory) {
        const catIref =
          typeof product.pCategory === 'string'
            ? product.pCategory
            : product.pCategory.iref;
        if (catIref) this.loadSubCategories(catIref);
      }
    }
  }

  pushData() {
    const maxAllowed = this.props.max || 5;
    if ((this.props.currentCount || 0) >= maxAllowed) {
      swal(
        "Limit reached.",
        `This product already has ${maxAllowed} recommendations. Remove an existing one to add another.`,
        "warning"
      );
      this.setState({ edit: false });
      this.props.productUpdated?.();
      return;
    }

    const payload = {};

    // parent product owning this recommendations list
    if (this.state.recommendedBy) {
      payload.recommendedBy = this.state.recommendedBy; // << IMPORTANT
    }

    // if editing an existing recommendation row, include its iref to update
    if (this.state.row?.iref) {
      payload.iref = this.state.row.iref;
    }

    // the product we’re adding as a recommendation
    if (this.state.product?.iref) {
      payload.productIref = this.state.product.iref;
    } else {
      // nothing selected; just exit edit mode
      this.setState({ edit: false });
      return;
    }

    // active flag (default true for new adds; tweak if you have a checkbox)
    payload.active = true;

    const res = this.state.client.pushData(this.state.saveURL, payload);
    if (res) {
      this.setState({ edit: false });
      this.props.productUpdated?.(); // refresh the row list
    }
  }

  removeChild = (productIref) => {
    const payload = {
      recommendedBy: this.state.recommendedBy, // parent product iref (Row passes it)
      productIref,                             // the child we’re removing
    };
    const res = this.state.client.pushData(Config.API_URL_RECOMMENDATIONS_REMOVE, payload);
    if (res) {
      this.props.productUpdated?.(); // refresh the list
    }
  };

  loadSubCategories(categoryIref) {
    try {
      const subMap = getSubCategoriesOnce(this.state.client, categoryIref);
      if (subMap) this.setState({ subCategories: subMap });
    } catch (e) { /* ignore */ }
  }

  render() {
    let iref = "";
    let key = "";
    let name = "";
    let type = "";
    let description = "";
    let status = 0;
    let sku = "";

    let pImage = noImage;
    let pCategoryName = "";
    let pSubCategoryName = "";
    let pCategoryImage = noImage;
    let pSubCategoryImage = noImage;
    let product_status_alt = "";
    let product_status_image = noImage;

    let product_iref = "";
    if ( this.props ) {
      if (this.props.row) {
        let row = this.props.row;

        if (row.iref) iref = row.iref;
        if (row.name) name = row.name;
        if (row.type) type = row?.type === "C" ? "[C] " : "[P] ";
        if (row.description) description = row.description;
        if (row.status !== undefined ) status = row.status;
        if (row.sku) sku = row.sku;

        product_iref = iref;

        if (row.pCategory) {
          const cat = this.state.categories?.[row.pCategory];
          if (cat) {
            pCategoryName = "Product Category: " + (cat.name || "");
            pCategoryImage = toAbsoluteImg(cat.image) || noImage;
          }
        }

        if (row.pSubCategory) {
          const sub = this.state.subCategories?.[row.pSubCategory];
          if (sub) {
            pSubCategoryName = "Product Subcategory: " + (sub.name || "");
            pSubCategoryImage = toAbsoluteImg(sub.image) || noImage;
          }
        }

        let pImg = row.productImage_product || row.comboImage_productCombo;
        if ( pImg ) {
          if ( pImg.length > 0 ) {
            pImage = pImg [ 0 ].image;
            for ( var i = 0; i < pImg.length; i++ ) {
              if ( pImg [ i ].isMain === true ) pImage = pImg [ i ].image;
            }
            let fileName = pImage.replace(/\.[^/.]+$/, "")
            let fileExtensions = pImage.split(".").pop();
            pImage = fileName + "_s." + fileExtensions;
          }        
        }

        switch ( row.status ) {
          case 0:
            product_status_image = registered;
            product_status_alt = "Registered";
            break;
          case 1:
            product_status_image = idle;
            product_status_alt = "Idle";
            break;
          case 2:
            product_status_image = active;
            product_status_alt = "Active";
            break;
          case 9:
            product_status_image = discontinued;
            product_status_alt = "Discontinued";
            break;
        }
      }
    }

    let productsSearch = [ ];
    if ( this.state.productsSearch )
      productsSearch = this.state.productsSearch;

    return (
      <React.Fragment>
        <TableRow key={key}>

          {!this.state.edit ?
            // <TableCell align="left">{iref}</TableCell>
            <TableCell align="left"></TableCell>
            : <TableCell/>
          }
          <TableCell align="left">
            <Box
              component="img"
              sx={{
                height: 48,
                width: 48,
                maxHeight: { xs: 233, md: 167 },
                maxWidth: { xs: 350, md: 250 },
                border: '1px dashed grey'
              }}
              alt="No Image"
              src={pImage}
            />
          </TableCell>

          <TableCell align="left" colSpan={1}>
            {this.state.edit ?
              <Autocomplete
                disablePortal
                id="product"
                key={product_iref}
                name="Product"
                options={productsSearch}
                sx={{ width: PRODUCT_COL_WIDTH }}
                getOptionLabel={(option) =>
                  typeof option === "string" ? option : option.label || ""
                }
                onChange={(e,v) => this.productChange(e, v, product_iref, iref)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Product (type keywords)"
                    onChange={this.productsSearch}
                  />
                )}
              />
            :
              <Box
                sx={{
                  width: PRODUCT_COL_WIDTH,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                <b>{type + name}</b>
              </Box>
            }
          </TableCell>

          <TableCell sx={{ minWidth: 96 }} >
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Avatar title={pCategoryName} alt={pCategoryName} src={pCategoryImage} sx={{ width: 48, height: 48 }}/>
              <Avatar title={pSubCategoryName} alt={pSubCategoryName} src={pSubCategoryImage} sx={{ width: 48, height: 48 }}/>
            </Box>
          </TableCell>

            {/* {!this.state.edit ?
              <TableCell>{description}</TableCell>
              : <TableCell/>
            } */}

          <TableCell>
            <Avatar alt={product_status_alt} src={product_status_image} title={product_status_alt}></Avatar>
          </TableCell>

          {/* <TableCell>{sku}</TableCell> */}

          <TableCell align="right">
            {!this.state.edit && iref ? (
              <IconButton
                aria-label="delete"
                onClick={() => this.removeChild(iref)}
                title="Remove from recommendations"
              >
                <DeleteForeverIcon sx={{ color: "#8f241d" }} />
              </IconButton>
            ) : null}
            {/* <IconButton aria-label="settings" onClick={this.handleEditClick}>
              <EditIcon sx={{ color: this.state.edit ? "#8f241d" : "#e3e3e5" }} />
            </IconButton> */}

            {this.state.edit ?
              <IconButton aria-label="settings" onClick={this.pushData}>
                <SaveIcon sx={{ color: "#4287f5" }} />
              </IconButton>
            : null}
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
}

class Row extends React.Component {

    constructor(props) {
      super(props);
  
      this.state = {
        client: new Client ( "none" ), 
        edit: false,   
        opened: false,
        productsSearch: [],
        product: {},
        row: {
          active: false,
        },
        saveURL: "",
        active: false,
        addProduct: false,
        isNew: false,
        showConfirm: false,
        removeIref: "",
        maxRecommends: 5,
        categories: this.props.categories || {},
        subCategories: this.props.subCategories || {},
      };
  
      this.handleEditClick = this.handleEditClick.bind(this);
      this.handleOpen = this.handleOpen.bind(this);
      this.productsSearch = this.productsSearch.bind(this);
      this.productChange = this.productChange.bind(this);
      this.pushData = this.pushData.bind(this);
      this.changeStatus = this.changeStatus.bind(this);
      this.toggleAdd = this.toggleAdd.bind(this);
      this.productUpdated = this.productUpdated.bind(this);
      this.loadSubCategories = this.loadSubCategories.bind(this);
      this.showConfirmDialog = this.showConfirmDialog.bind(this);
      this.removeConfirm = this.removeConfirm.bind(this);
      this.removeCancel = this.removeCancel.bind(this);
    }

    componentDidMount () {
      if (this.props) {
        if (this.props.isNew === true) {
          this.setState ({isNew: true});
          this.handleEditClick();
        }
        if (this.props.row)
          this.setState ( {row: this.props.row } );
        if (this.props.saveURL) this.setState ( { saveURL: this.props.saveURL } );
        // prefetch subcategories for this product’s category (pCategory is an iref)
        const pc = this.props.row?.product?.pCategory;
        if (pc) this.loadSubCategories(pc);
      }
      if (this.props.maxRecommends != null) {
        this.setState({ maxRecommends: this.props.maxRecommends });
      }
    }

    componentDidUpdate (prevProps) {
      if (prevProps !== this.props) {
        if (this.props) {
          /* if (this.props.isNew === true) {
            this.handleEditClick();
          } */
          if (this.props.row) this.setState ( {row: this.props.row } );
          if (this.props.saveURL) this.setState ( { saveURL: this.props.saveURL } );
          // if product category changed, refresh subcategories
          const prevPC = prevProps.row?.product?.pCategory;
          const currPC = this.props.row?.product?.pCategory;
          if (currPC && currPC !== prevPC) this.loadSubCategories(currPC);
        }
      }
    }

    toggleAdd ( ) {
      let doAdd = this.state.addProduct;
      this.setState ( {addProduct: !doAdd} );
    }

    handleOpen ( ) {
      let opened = this.state.opened;
      this.setState ( { opened: !opened } );
    }

    handleEditClick ( ) {
      let cEdit = !this.state.edit;
      this.setState({ edit: !this.state.edit });
    }

    productsSearch ( e ) {
      if ( e.target.value.length > 2 ) {
        let queryData = {
          "nameLike" : e.target.value,
          "isForSale": 1,
          "status": 2,
          "noRecommends": 1,
          "orderBy_name": true,
        };

        // 1) PRODUCTS
        let data = this.state.client.filterProducts({ ...queryData, "isSoldAlone": 1 });
        let newProducts = [];
        let users = [];
        if (data && data.products && data.products.length > 0) {
          Object.keys(data.products).forEach(key => {
            let fData = data.products [ key ];
            let name = fData.name;
            let lineText = name;
            lineText += " (";
            if (fData.pCategory && fData.pCategory.name)
              lineText += fData.pCategory.name;
            if ( fData.pSubCategory && fData.pSubCategory.name )
              lineText += "/" + fData.pSubCategory.name + ")";
            else
              lineText += ")";
            let newObj = { key: fData.iref, label: "[P] " + lineText, type: "product" };
            newProducts.push ( newObj );
            users.push ( fData );
          });
        }

        // 2) COMBOS – use filterCombos, response uses productCombos
        let combosData = this.state.client.filterCombos(queryData);
        if (combosData && combosData.productCombos && combosData.productCombos.length > 0) {
          Object.keys(combosData.productCombos).forEach(key => {
            let fData = combosData.productCombos[key];
            let name = fData.name;
            let lineText = name;
            lineText += " (";
            if (fData.pCategory && fData.pCategory.name)
              lineText += fData.pCategory.name;
            if ( fData.pSubCategory && fData.pSubCategory.name )
              lineText += "/" + fData.pSubCategory.name + ")";
            else
              lineText += ")";
            let newObj = { key: fData.iref, label: "[C] " + lineText, type: "combo" };
            newProducts.push ( newObj );
            users.push ( fData );
          });
        }

        this.setState ( { productsSearch: newProducts });
      }
    }

    productChange ( e, v, productIref, recommIref ) {
      if (!v || !v.key) return;
      let queryData = { iref: v.key };

      // 1) Try PRODUCT endpoint
      let data = this.state.client.getData ( Config.API_URL_PRODUCT, queryData );
      let product = null;
      if (data && data.products && data.products.length === 1) {
        product = data.products[0];
      }

      // 2) If not found as product, try COMBO endpoint
      if (!product) {
        let comboData = this.state.client.getData(Config.API_URL_COMBO, queryData);
        if (comboData && comboData.productCombos && comboData.productCombos.length === 1) {
          product = comboData.productCombos[0]; // still call it "product" to avoid other changes
        }
      }

      if (product) {
        this.setState({ product: product });
      }
    }

    pushData() {
      const row = this.state.row || {};
      const isNew = !!this.state.isNew || !row.iref;

      const payload = {};
      if (isNew) {
        // create a container for the selected parent product
        if (!this.state.product?.iref) { this.setState({ edit:false }); return; }
        payload.productIref = this.state.product.iref;   // parent product
        payload.active = !!row.active;
      } else {
        // update only 'active'
        payload.iref = row.iref;                         // container iref
        payload.active = !!row.active;
      }

      const res = this.state.client.pushData(Config.API_URL_RECOMMENDATIONS_ADD, payload);
      if (res) {
        this.setState({ edit:false, isNew:false });
        this.props.recommendationUpdated?.();
      }
    }

    changeStatus ( e ) {
      let row = this.state.row;
      let nActive = !row.active;
      row.active = nActive;
      this.setState ({row: row});
    }

    productUpdated () {
      // Close the inline add row → switch button back to "+"
      if (this.state.addProduct) this.setState({ addProduct: false });

      // Ask the parent to reload (Recommendations -> getData)
      this.props.recommendationUpdated?.();
    }

    showConfirmDialog ( e ) {
      this.setState ( { showConfirm: true } );
      this.setState ( { removeIref: e } );
    }

    removeConfirm ( iref ) {
      let removeIref = this.state.removeIref;
      this.removeImage ( removeIref );
      this.setState ( { showConfirm: false } );
      this.setState ( { removeIref: "" } );
    }
  
    removeCancel ( ) {
      this.setState ( { showConfirm: false } );
      this.setState ( { removeIref: "" } );
    }

    loadSubCategories(categoryIref) {
      try {
        const subMap = getSubCategoriesOnce(this.state.client, categoryIref);
        if (subMap) this.setState({ subCategories: subMap });
      } catch (e) { /* ignore */ }
    }

    render() {

      let row = {};
      if ( this.state.row ) row = this.state.row;

      let iref = "";
      let productName = "Undefined";
      let productType = "";
      let pImage = noImage;
      let pCategoryName = "";
      let pSubCategoryName = "";
      let pCategoryImage = noImage;
      let pSubCategoryImage = noImage;
      let productDescription = "Undefined";
      let productSKU = "Undefined";
      let productActive = false;
      let active = false;
      let product_iref = "";

      if (row.active !== undefined) active = row.active;

      let product = row.product;
      if ( product ) {
        iref = product.iref;
        product_iref = iref;
        productName = product.name;
        productType = product?.type === "C" ? "[C] " : "[P] ";
        productDescription = product.description;
        productSKU = product.sku;

        if ( product.status === 2 ) productActive = true;

        if (product.pCategory) {
          const cat = this.state.categories?.[product.pCategory];
          if (cat) {
            pCategoryName = cat.name || "";
            pCategoryImage = toAbsoluteImg(cat.image) || noImage;
          }
        }

        if (product.pSubCategory) {
          const sub = this.state.subCategories?.[product.pSubCategory];
          if (sub) {
            pSubCategoryName = "Product Subcategory: " + (sub.name || "");
            pSubCategoryImage = toAbsoluteImg(sub.image) || noImage;
          }
        }

        let pImg = product.productImage_product || product.comboImage_productCombo;
        if ( pImg ) {
          if ( pImg.length > 0 ) {
            pImage = pImg [ 0 ].image;
            for ( var i = 0; i < pImg.length; i++ ) {
              if ( pImg [ i ].isMain === true ) pImage = pImg [ i ].image;
            }
            let fileName = pImage.replace(/\.[^/.]+$/, "")
            let fileExtensions = pImage.split(".").pop();
            pImage = fileName + "_s." + fileExtensions;
          }        
        }
      }

      let recommendsCounter = 0;
      if ( row.recommends ) recommendsCounter += row.recommends.length;
    
      let recommendsList = [];
      if ( row.recommends ) {
          let recommendsListObject = Object.entries ( row.recommends );
          if ( recommendsListObject.length > 0 ) recommendsList = recommendsListObject;
      }
      
      let productsSearch = [ ];
        if ( this.state.productsSearch ) productsSearch = this.state.productsSearch;

    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>

          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => this.handleOpen()}
            >
              {this.state.opened ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>          
          </TableCell>

          {/* <TableCell align="left">{iref}</TableCell> */}
          <TableCell align="left">
            <Box
              component="img"
              sx={{
                height: 48,
                width: 48,
                maxHeight: { xs: 233, md: 167 },
                maxWidth: { xs: 350, md: 250 },
                border: '1px dashed grey'
              }}
              alt="No Image"
              src={pImage}
            />
          </TableCell>

          <TableCell align="left">
            {(this.state.edit && this.state.isNew) ? (
                <Autocomplete
                  disablePortal
                  id="parent-product"
                  options={productsSearch}
                  sx={{ width: PRODUCT_COL_WIDTH }}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.label || ""
                  }
                  onChange={(e,v) => this.productChange(e, v, product_iref, iref)}
                  renderInput={(params) => (
                    <TextField {...params} label="Parent product (search)" onChange={this.productsSearch}/>
                  )}
                />
            ) : (
              <Box
                sx={{
                  width: PRODUCT_COL_WIDTH,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                <b>{productType + productName}</b>
              </Box>
          )}
          </TableCell>
          <TableCell sx={{ minWidth: 96 }} >
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Avatar title={pCategoryName} alt={pCategoryName} src={pCategoryImage} sx={{ width: 48, height: 48 }}/>
              <Avatar title={pSubCategoryName} alt={pSubCategoryName} src={pSubCategoryImage} sx={{ width: 48, height: 48 }}/>
            </Box>
          </TableCell>
          {/* {!this.state.edit ?
            <TableCell align="left" sx={{minWidth: 72}}>
              {productDescription}
            </TableCell>
            : ""
          } */}
            {/* <TableCell align="left">
              {productSKU}
            </TableCell> */}

            <TableCell align="left">
              {recommendsCounter}
            </TableCell>

            <TableCell align="left">
              {/* <FormControlLabel
                control={
                  <Switch
                    checked={!!(this.state.row?.active)}
                    disabled={!this.state.edit || !!this.state.isNew}
                    onChange={(e) =>
                      this.setState((s) => ({ row: { ...s.row, active: e.target.checked } }))
                    }
                  />
                }
                label="Active"
              /> */}
              {this.state.edit ?
                <Checkbox 
                  id="active" 
                  color="success" 
                  checked={active} 
                  onChange={(e) =>
                      this.setState((s) => ({ row: { ...s.row, active: e.target.checked } }))
                    }
                />
                :
                <Checkbox  color="success" checked={active} disabled/>
              }
            </TableCell>

          <TableCell align="right">
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1 }}>
              {!this.state.edit ? (
                <IconButton
                  size="small"
                  aria-label="edit"
                  onClick={() => this.setState({ edit: true })}
                  title="Edit"
                >
                  <EditIcon sx={{ color: this.state.edit ? "#8f241d" : "#e3e3e5" }} fontSize="small" />
                </IconButton>
              ) : (
                <>
                  <IconButton
                    size="small"
                    aria-label="save"
                    onClick={() => this.pushData()}
                    title="Save"
                  >
                    <SaveIcon sx={{ color: "#4287f5" }} fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    aria-label="cancel"
                    onClick={() => this.setState({ edit: false })}
                    title="Cancel"
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </>
              )}
            </Box>
            {/* {this.state.edit && !this.state.isNew ?
              <IconButton aria-label="delete" id={product_iref} onClick={() => {this.showConfirmDialog(product_iref);}}>
                <DeleteForeverIcon
                  sx={{ color: "#8f241d" }}              
                />
              </IconButton>
            : ""} */}

            <Dialog
              open={!!this.state.showConfirm}
              TransitionComponent={Transition}
              keepMounted
              onClose={this.removeCancel}
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle>{"Remove product recommendation ?"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    This action will only remove the product from the recommendation list.
                  </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.removeCancel}>No</Button>
                <Button onClick={() => {this.removeConfirm(product_iref);}}>Yes</Button>
              </DialogActions>
            </Dialog>

          </TableCell>

        </TableRow>

        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0, width: "100% !important", minWidth: 700 }} colSpan={6}>
            
            <Collapse in={this.state.opened} timeout="auto" unmountOnExit sx={{width: "100% !important"}}>

              <Box sx={{ margin: 1, minWidth: 700, width: "100% !important" }}>
                <Typography variant="body1" gutterBottom component="div">
                  Recommended products
                </Typography>
                <Table size="small" aria-label="purchases" sx={{minWidth: 700, backgroundColor: "#eeeee4"}}>
                  <TableHead sx={{backgroundColor: "#ddddd4"}}>
                    <TableRow>
                    <TableCell>
                      <IconButton
                        aria-label="Add Product"
                        title="Add Product"
                        onClick={() => {
                          if (recommendsCounter  >= this.state.maxRecommends) {
                            swal(
                              "Limit reached.",
                              `You can recommend up to ${this.state.maxRecommends} products. Remove an existing one to add another.`,
                              "warning"
                            );
                            return;
                          }
                          this.toggleAdd();
                        }}
                      >
                        <Avatar alt="Add Product" sx={{ width: 20, height: 20, color: "#273442" }}>
                          {this.state.addProduct ? <FaMinusCircle/> : <FaPlusCircle/>}
                        </Avatar>
                      </IconButton>
                    </TableCell>
                      {/* <TableCell align="left">Iref</TableCell> */}
                      <TableCell align="left">Image</TableCell>
                      <TableCell align="left" sx={{ width: PRODUCT_COL_WIDTH }}>Name</TableCell>
                      <TableCell align="left">Category/SubCategory</TableCell>
                      {/* <TableCell align="left">Description</TableCell> */}
                      <TableCell align="left">Status</TableCell>
                      {/* <TableCell align="left">SKU</TableCell> */}
                      <TableCell align="right">Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.addProduct ?
                      <RecommendsRow
                        key = {0}
                        row = {{}}
                        isNew = {true}
                        recommendedBy = {iref}
                        saveURL={Config.API_URL_RECOMMENDATIONS_ADD}
                        productUpdated={this.productUpdated}
                        categories={this.state.categories}
                        subCategories={this.state.subCategories}
                        currentCount={recommendsCounter}
                        max={this.state.maxRecommends}           
                      />
                      : ""
                    }
                    {recommendsList.map((pData) => (                      
                      <RecommendsRow
                        key = {pData[1].iref}
                        row = {pData[1]}
                        recommendedBy = {iref}
                        saveURL={Config.API_URL_RECOMMENDATIONS_ADD}
                        productUpdated={this.productUpdated}
                        categories={this.state.categories}
                        subCategories={this.state.subCategories}
                      >                        
                      </RecommendsRow>                      
                    ))}
                    
                  </TableBody>
                </Table>
              </Box>
              
            </Collapse>

          </TableCell>

        </TableRow>


      </React.Fragment>
    );
  }
}

class Recommendations extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      client: new Client ( "none" ), 
      addNewList: false, 
      productRecommendations: null,
      locations: {},
      catetgories: {},
      subCategories: {},
      maxRecommends: 5,
    };

    this.applyFilters = this.applyFilters.bind(this);    
    this.toggleAdd = this.toggleAdd.bind(this);
    this.getData = this.getData.bind(this);
    this.recommendationUpdated = this.recommendationUpdated.bind(this);
    this.getCategories = this.getCategories.bind(this);
    this.getSubCategories = this.getSubCategories.bind(this);
  }

  componentDidMount() {    
    this.getData();
    this.getCategories();
    // if current row already has a category, prefetch its subcats
    if (this.props?.row?.pCategory?.iref) this.getSubCategories(this.props.row.pCategory.iref);
    const cfg = this.state.client.getData(Config.API_URL_CONFIG_SALESAPP,{ key: "RECOMM_PRODUCTS_MAX" });
    const v = cfg?.SalesAppConfigs?.[0]?.value;
    const max = v ? (parseInt(v, 10) || 5) : 5;
    this.setState({ maxRecommends: max });
    }

  getData ( ) {
    let queryData = {};
    queryData [ "orderBy_Name" ] = true;
    queryData [ "limit" ] = 20;
    let productRecommendations = this.state.client.getData ( Config.API_URL_RECOMMENDATIONS, queryData );
    this.setState ( { productRecommendations: productRecommendations.productRecommendations });
  }

  getCategories ( ) {
    let data = this.state.client.getProductsCategories ( );
    if ( data ) {
      let categories = {};
      for ( var i = 0; i < data.productCategories.length; i++ ) {
        // let newClass = {};
        categories[ data.productCategories[ i ].iref ] = {          
          "name": data.productCategories[ i ].name,
          "image": data.productCategories[ i ].image
          }
      }
      this.setState ( { categories: categories } );
      this.setState ( { acategories: data.productCategories } );
    }
  }

  getSubCategories ( category ) {
    let queryData = {
      "category": category
    };
    let data = this.state.client.getProductsSubCategories ( queryData );
    if ( data ) {
      let subCategories = {};
      for ( var i = 0; i < data.productSubCategories.length; i++ ) {
        subCategories[ data.productSubCategories[ i ].iref ] = {          
          "name": data.productSubCategories[ i ].name,
          "image": data.productSubCategories[ i ].image
          }
      }
      this.setState ( { subCategories: subCategories } );
      this.setState ( { asubCategories: data.productSubCategories } );
    }
  }

  recommendationUpdated () {
    if (this.state.addNewList)
      this.toggleAdd();
    this.getData();
  }

  //Function to change the main Products filter state
  applyFilters ( queryData ) {
    if ( queryData ) {
      queryData [ "orderBy_name" ] = true;
      queryData [ "limit" ] = 20;
      let productRecommendations = this.state.client.getData ( Config.API_URL_RECOMMENDATIONS, queryData );
      this.setState ( { productRecommendations: productRecommendations.productRecommendations });
    }
  }

  toggleAdd ( ) {
    let doAdd = this.state.addNewList;
    this.setState ( {addNewList: !doAdd} );
  }

  render() {

    let productsCounter = 0;
    if ( this.state.productRecommendations ) {
      productsCounter = this.state.productRecommendations.length;
    }

    let rows = "";
    let listsCounter = 0;
    if ( this.state.productRecommendations ) {
      if ( this.state.productRecommendations.length > 0 ) {
        listsCounter = this.state.productRecommendations.length;
        rows = this.state.productRecommendations.map((row) => {
          return <Row
            key={row.iref}
            row={row}
            categories={this.state.categories}
            subCategories={this.state.subCategories}
            recommendationUpdated={this.recommendationUpdated}
            saveURL={Config.API_URL_RECOMMENDATIONS_ADD}
            maxRecommends={this.state.maxRecommends} 
            />
        });
      }
    }

    return (
      <div style={{ backgroundColor: "#273442", height: "100%" }}>
        <div className='sticky'>
          <RecomFilters
              applyFilters = {this.applyFilters}
              listsCounter = {listsCounter}
              toggleAdd = {this.toggleAdd}
              applyCategory = {this.applyCategory}
              classesList = {this.state.productClasses}
              categoriesList = {this.state.productCategories}
              subCategoriesList = {this.state.productSubCategories}
              allergensList = {this.state.allergens}
              productsCounter = {productsCounter}
            />
        </div>
        <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead sx={{backgroundColor: "#273442", color: "#FFFFFF !important"}}>
            <TableRow sx={{backgroundColor: "#273442", color: "#FFFFFF !important"}}>
              

              <TableCell>
                <IconButton aria-label="Add Recommendations" title="Add Recommendations" onClick={() => this.toggleAdd()}>       
                  <Avatar alt="Add Recommendations" sx={{ width: 24, height: 24, color: "#273442" }}>
                    {this.state.addNewList ? <FaMinusCircle/> : <FaPlusCircle/>}
                  </Avatar>
                </IconButton>
              </TableCell>

              {/* <TableCell align="left" sx={{backgroundColor: "#273442", color: "#FFFFFF !important"}}>Iref</TableCell> */}
              <TableCell align="left" sx={{backgroundColor: "#273442", color: "#FFFFFF !important"}}>Image</TableCell>
              <TableCell align="left" sx={{width: PRODUCT_COL_WIDTH, backgroundColor: "#273442", color: "#FFFFFF !important"}}>Product Name</TableCell>
              <TableCell align="left" sx={{backgroundColor: "#273442", color: "#FFFFFF !important"}}>Category/SubCategory</TableCell>
              {/* <TableCell align="left" sx={{backgroundColor: "#273442", color: "#FFFFFF !important"}}>Description</TableCell> */}
              {/* <TableCell align="left" sx={{backgroundColor: "#273442", color: "#FFFFFF !important"}}>SKU</TableCell> */}
              <TableCell align="left" sx={{backgroundColor: "#273442", color: "#FFFFFF !important"}}>Recom Counter</TableCell>
              <TableCell align="left" sx={{backgroundColor: "#273442", color: "#FFFFFF !important"}}>Status</TableCell>
              <TableCell align="right" sx={{backgroundColor: "#273442", color: "#FFFFFF !important"}}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.addNewList ? 
              <Row
                key="0"
                isNew={true}
                row={{ active: true }} 
                saveURL={Config.API_URL_RECOMMENDATIONS_ADD}
                recommendationUpdated={this.recommendationUpdated}
                maxRecommends={this.state.maxRecommends}
              />
            : ""
            }
            {rows}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
    );
  }
}

export default Recommendations;
